import React, { useState, useEffect } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Accordion, { AccordionItem } from '../@base/Accordion';
import TextArea from '../@base/TextArea';
import TagInput from '../TagsInput/TagsInput';
import {
  Validation, preparingInput, getParameter, onValidHandler, handleInputValid,
} from './Commons';

import styles from './SharedStyle.module.css';

const ImproperliesComponent = (props) => {
  if (!props.component.parameters) return null;

  const [terms, setTerms] = useState(null);

  const parameterList = props.component.parameters;
  const improprietyList = getParameter(parameterList, 'impropriety.list');
  const message = getParameter(parameterList, 'impropriety.answer');

  improprietyList.value = improprietyList.value ? improprietyList.value : '';
  message.value = message.value ? message.value : '';

  const [inputValid, setInputValid] = useState({});

  useEffect(() => {
    const helperContent = (
      <div>
        {ReactHtmlParser(`${props.component.description} Nesse componente podem ser configurados:`)}
        <ul>
          <li>{ReactHtmlParser(message.parameter.hint)}</li>
          <li>{ReactHtmlParser(improprietyList.parameter.hint)}</li>
        </ul>
      </div>
    );
    props.setHelperContent(<div>{helperContent}</div>);
  }, []);

  useEffect(() => {
    handleInputValid(inputValid, props);
  }, [inputValid]);

  useEffect(() => {
    if (props.component.parameters) {
      let _terms = improprietyList.value.split(',').filter((v) => v !== '');
      _terms = _terms.map((t, i) => ({ id: `${i}`, text: t }));
      setTerms(_terms);
    }
  }, [props.component]);

  useEffect(() => {
    if (!terms) return;
    const _value = terms.map((t) => t.text).join(',');

    if (_value === improprietyList.value) return;
    props.updateParameter({
      ...improprietyList,
      value: _value,
    });
  }, [terms]);

  return (
    <Accordion>
      <AccordionItem active title={ReactHtmlParser(message.parameter.hint)}>
        <div>Mensagem de resposta às impropriedades</div>
        <div className={styles.ComponentSubList}>
          {preparingInput(<TextArea
            placeholder="Digite a mensagem"
          />, message, props, onValidHandler(setInputValid, message))}
        </div>
      </AccordionItem>
      <AccordionItem active>
        <div>Palavras ou expressões impróprias</div>
        <Validation isValid={onValidHandler(setInputValid, improprietyList)}>
          <TagInput
            value={terms}
            onChange={(e) => setTerms(e)}
            placeholder="Digite"
            classes={styles.TagsInput}
            mandatory={improprietyList.parameter.mandatory}
          />
        </Validation>
      </AccordionItem>
      {props.localizationAccordionItem || null}
      {/* <AccordionItem>
        <div>Como Funciona</div>
        <div>
          {ReactHtmlParser(props.component.description)}
          . Nesse componente podem ser configurados:
          <ul>
            <li>
              {ReactHtmlParser(message.parameter.hint)}
            </li>
            <li>
              {ReactHtmlParser(improprietyList.parameter.hint)}
            </li>
          </ul>
        </div>
      </AccordionItem> */}
    </Accordion>
  );
};

export default ImproperliesComponent;
